module.exports = {"320117001":"永阳街道","320117002":"柘塘街道","320117101":"白马镇","320117102":"东屏镇","320117104":"石湫镇","320117105":"洪蓝镇","320117106":"晶桥镇","320117107":"和凤镇","320117400":"溧水开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320117.json
// module id = 772
// module chunks = 0